<template>
  <div class="router-nav">

    <router-link
      :to="{name: 'home'}"
      class="d-inline-block d-flex flex-items-center usn mr-3 only-for-exact"
      @click.native="hideMobileHeaderPad()"
      >
      {{lg('',{
        en: 'Marketplace',
        zh: '交易市场',
      })}}
    </router-link>

    <router-link
      :to="{name: 'store'}"
      class="d-inline-block d-flex flex-items-center usn mr-3 only-for-exact"
      @click.native="hideMobileHeaderPad()"
      >
      {{lg('',{
        en: 'Stores',
        zh: '商城',
      })}}
    </router-link>

    <!-- <router-link
      :to="{name: 'activity'}"
      class="d-inline-block d-flex flex-items-center usn mr-3"
      @click.native="hideMobileHeaderPad()"
      >
      {{lg('',{
        en: 'Activity',
        zh: '交易记录',
      })}}
    </router-link> -->

    <!-- <router-link
      :to="{name: 'wallet'}"
      class="d-inline-block d-flex flex-items-center usn mr-3"
      @click.native="hideMobileHeaderPad()"
      >
      {{lg('',{
        en: 'Wallet',
        zh: '钱包总额',
      })}}
    </router-link> -->

    <router-link
      :to="{name: 'gallery'}"
      class="d-inline-block d-flex flex-items-center usn mr-3"
      @click.native="hideMobileHeaderPad()"
      >
      {{lg('',{
        en: 'My Collection',
        zh: '我的收藏',
      })}}
    </router-link>

    <router-link
      :to="{name: 'create'}"
      class="d-inline-block d-flex flex-items-center usn mr-3"
      @click.native="hideMobileHeaderPad()"
      >
      {{lg('',{
        en: 'Create',
        zh: '创建',
      })}}
    </router-link>

    <!-- <router-link
      :to="{name: 'profile'}"
      class="d-inline-block d-flex flex-items-center usn mr-3"
      @click.native="hideMobileHeaderPad()"
      >
      {{lg('',{
        en: 'Profile',
        zh: '用户资料',
      })}}
    </router-link> -->

    <!-- <a 
      :href="`https://faq.com`"
      target="_blank"
      class="d-inline-block d-flex flex-items-center usn mr-3"
      >
      {{lg('',{
        en: 'FAQ',
        zh: '小助手',
      })}}
    </a> -->



  </div>
</template>

<script>

export default {
  name: 'headerNavItems',
  components: {},
  props: [],
  data() {
    return {
      
    }
  },
  computed: {},
  watch: {},
  methods: {
    hideMobileHeaderPad(){
      this.$parent.$emit('hideMobileHeaderPad')
    },
  },
  created() {
    
  },
  //mounted() {},
  //beforeDestroy() {},
  //update() {},
  //activited() {},
  //beforeRouteUpdate() {},
  //filters: {},
};
</script>

<style lang="scss" scoped>
  @import "~@/assets/css/vars.scss";

  @media(min-width: 788px){
    .router-nav{
      a{
        // color: var(--text-color);
        color: #888;
        &.router-link-active:not(.only-for-exact),&.router-link-exact-active{
          color: #fff !important;
        }
        &:hover{
          color: #eee !important;
        }
      }
    }
  }
</style>